<p-tabMenu [model]="stockFeatures" [activeItem]="selectedFeature"></p-tabMenu>
<router-outlet></router-outlet>
